import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1252242806993118';
const PIXEL_SCRIPT_ID = 'meta-pixel-base-code';
type FacebookPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  loaded?: boolean;
  push?: FacebookPixel;
  queue?: unknown[][];
  version?: string;
};
declare global {
  interface Window {
    fbq?: FacebookPixel;
    _fbq?: FacebookPixel;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
        return;
      }
      fbq.queue?.push(args);
    }) as FacebookPixel;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    fbq.push = fbq;
    window.fbq = fbq;
    window._fbq = fbq;
    if (!document.getElementById(PIXEL_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = PIXEL_SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return null;
}